import { render, staticRenderFns } from "./AppPreparationDocumentObservation.vue?vue&type=template&id=0706a970&"
import script from "./AppPreparationDocumentObservation.vue?vue&type=script&lang=js&"
export * from "./AppPreparationDocumentObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports